<template>
	<transition name="my-modal">
		<div class="my-modal-mask">
			<div class="my-modal-wrapper">
				<div class="my-modal-container">
					<div class="my-modal-header">
						<slot name="header">
							default header
						</slot>
					</div>
					<div class="my-modal-body">
						<slot name="body">
							default body
						</slot>
					</div>
					<div class="my-modal-footer">
						<slot name="footer-ok" v-if="withOkBtn">
							<button class="my-modal-btn" @click="$emit('ok')">
								<span class="spinner-border spinner-border-sm text-light" :class="{'show-spinner': showSpinner}" role="status"></span>
								{{okBtnText}}
							</button>
						</slot>
						<slot name="footer-cancel" v-if="withCancelBtn">
							<button class="my-modal-btn" @click="$emit('close')">
								{{cancelBtnText}}
							</button>
						</slot>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
	export default {
		name: 'Modal',
		props: {
			okBtnText: {
				type: String,
				default: 'Ok'
			},
			cancelBtnText: {
				type: String,
				default: 'Cancel'
			},
			withOkBtn: {
				type: Boolean,
				default: true
			},
			withCancelBtn: {
				type: Boolean,
				default: true
			},
			showSpinner: {
				type: Boolean,
				default: false
			}
		}
	}
</script>

<style>
	.my-modal-mask {
		position: fixed;
		z-index: 9998;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, .5);
		display: table;
		transition: opacity .3s ease;
	}

	.my-modal-wrapper {
		display: table-cell;
		vertical-align: middle;
	}

	.my-modal-container {
		width: 90%;
		margin: 0px auto;
		color: #ffffff;
		background-color: #33363d;
		border-radius: 2px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
		transition: all .3s ease;
		font-family: inherit;
		border-radius: 4px;
	}

	.my-modal-header {
		text-align: center;
		font-size: 30px;
		padding: 10px 0;
		border-bottom: 1px solid #f2f2f2;
	}

	.my-modal-body {
		text-align: center;
		background-color: #33363d;
		font-size: 16px;
		padding: 20px;
	}

	.my-modal-default-button {
		background-color: none;
		border: none;
	}

	.my-modal-footer {
		text-align: center;
		border-top: 1px solid #f2f2f2;
	}

	.my-modal-btn {
		font-family: inherit;
		font-size: 16px;
		font-weight: 500;
		color: #ffffff;
		background-color: #5cc1a6;
		border: 2px solid #5cc1a6;
		border-radius: 30px;
		padding: 6px 12px;
		width: 100px;
		margin: 10px;
		cursor: pointer;
	}

	.my-modal-btn:focus {
		outline: none;
		border: 2px solid #3fa68b;
		color: white;
	}

	@media screen and (min-width: 769px) {
		.my-modal-container {
			width: 50%;
			max-width: 500px;
		}

		.my-modal-body {
			padding: 20px;
		}
	}

	.my-modal-enter {
		opacity: 0;
	}

	.my-modal-leave-active {
		opacity: 0;
	}

	.my-modal-enter .my-modal-container,
	.my-modal-leave-active .my-modal-container {
		-webkit-transform: scale(1.1);
		transform: scale(1.1);
	}

	.spinner-border {
		display: none;
	}

	.show-spinner {
		display: inline-block;
	}
</style>